import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Switch} from '@material-ui/core';
import React from 'react';
import {useDispatch} from 'react-redux';
import RequiredTextInput from 'Shared/components/RequiredTextInput';
import ValidatableEmailInput from 'Shared/components/ValidatableEmailInput';
import ValidatablePhoneInput from 'Shared/components/ValidatablePhoneInput';
import ValidatableTextInput from 'Shared/components/ValidatableTextInput';
import {
  changeAccountType,
  changeFirstName,
  changeLastName,
  resetUserTypeState,
  validateEmail,
  validatePhoneNumber,
  validateUserName,
  changeIsUserDisable
} from 'Users/ducks/userEntry';
import {
  AccountType,
  BasicInformation,
  EmptyBasicInformation,
  isExternalBasicInformation,
} from 'Users/models/User/BasicInformation';
import './BasicUserInformationEntry.sass';

type BasicUserInformationEntryProps = {
  basicUserInformation: BasicInformation;
  isEdit?: boolean;
};

const BasicUserInformationEntry = (props: BasicUserInformationEntryProps) => {
  const {firstName, lastName, email, accountType, isDisabled} = props.basicUserInformation;
  const {isEdit} = props;
  const dispatch = useDispatch();

  return (
    <>
      <div className="basic-user-information-section">
        <FormControl component="fieldset" disabled={isEdit} className="basic-user-information-section__radio-group">
          <FormLabel component="legend" className="basic-user-information-section__radio-group-label">
            Account Type
          </FormLabel>
          <RadioGroup
            row
            name="user-type"
            value={accountType}
            onChange={e => {
              dispatch(resetUserTypeState());
              dispatch(changeAccountType(e.target.value as AccountType));
            }}
          >
            <FormControlLabel
              control={<Radio checked={accountType === 'Internal'} color="primary" />}
              label={
                <span>
                  Internal
                  <br />
                  <span className="basic-user-information-section__login-method-description">
                    This user has an Allstate NTID and will immediately be able to login to MyAccess when the user is
                    created.
                  </span>
                </span>
              }
              value="Internal"
              className="basic-user-information-section__radio-label"
            />
            <FormControlLabel
              control={<Radio checked={accountType === 'External'} color="primary" />}
              label={
                <span>
                  External
                  <br />
                  <span className="basic-user-information-section__login-method-description">
                    This user does not have an Allstate NTID and will be sent an invitation via email to create a
                    MyAccess account.
                  </span>
                </span>
              }
              value="External"
              className="basic-user-information-section__radio-label"
            />
          </RadioGroup>
        </FormControl>
        <p className="basic-user-information-section__header">Basic User Information</p>
        <p className="basic-user-information-section__description">
          Please supply the user's name and contact information below.
        </p>
        <RequiredTextInput
          label="First Name"
          className="basic-user-information-section__field"
          onChange={firstName => dispatch(changeFirstName(firstName.value))}
          value={firstName}
        />
        <RequiredTextInput
          label="Last Name"
          className="basic-user-information-section__field"
          onChange={lastName => dispatch(changeLastName(lastName.value))}
          value={lastName}
        />
        <ValidatableEmailInput
          label="Email"
          className="basic-user-information-section__field"
          onValidate={email => dispatch(validateEmail(email))}
          value={email}
        />
        {(!isExternalBasicInformation(props.basicUserInformation) || isEdit) && (
          <>
            <ValidatableTextInput
              label="Username"
              className="basic-user-information-section__field"
              onValidate={username => dispatch(validateUserName(username))}
              value={props.basicUserInformation.username || EmptyBasicInformation.username}
              disabled={isEdit}
            />
            <ValidatablePhoneInput
              label="Phone Number"
              className="basic-user-information-section__field"
              onValidate={phone => dispatch(validatePhoneNumber(phone))}
              value={props.basicUserInformation.phoneNumber || EmptyBasicInformation.phoneNumber}
            />
          </>
        )}
        {isEdit && (
          <FormControlLabel
            className="agency-input__administrator-checkbox"
            label="User Profile Disabled"
            control={
              <Switch
                color="primary"
                checked={isDisabled}
                onChange={e => dispatch(changeIsUserDisable(e.target.checked))}
              />
            }
          />
        )}
      </div>
    </>
  );
};

export default BasicUserInformationEntry;
